import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
    selector: 'app-base-reaction',
    templateUrl: './base-reaction.component.html',
    styleUrls: ['./base-reaction.component.css'],
})
export class BaseReactionComponent implements OnInit {
    @Input() reactIndex = 0
    @Input() disabled = false
    @Output() _onReact: EventEmitter<number> = new EventEmitter<number>()

    heartClassName: string = 'hidden'

    constructor() {
    }

    ngOnInit() {
        this.heartClassName = this.getClassName()
    }

    getClassName() {
        let className = ''
        switch (this.reactIndex) {
            case 1:
                className = 'fa-heart'
                break
            case 2:
                className = 'fa-heart-broken'
                break

            default:
                className = 'fa-heart-o'
        }
        if (this.disabled) {
            className += ' disabled-icon'
        }

        return className
    }

    changeReact(event) {
        event.stopPropagation()
        if (this.disabled) {
            return
        }
        this.reactIndex = Math.abs((this.reactIndex || 0) - 1)
        this.heartClassName = this.getClassName()

        this._onReact.emit(this.reactIndex)
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/base-reaction/base-reaction.component.ts